import React, { MouseEvent } from "react";
import cx from "classnames";
import { useTranslation } from "i18n";
import { SocialMediaPlatformCode } from "shared-types";
import "./SocialMediaPillStyles.scss";
import {
  CrossThinIcon as CloseIcon,
  InstagramColoredIcon as InstagramIcon,
} from "assets";
import { getSocialPillText } from "./helpers/getSocialPillText";
import { IconTextLink } from "../../Atoms/IconTextLink/IconTextLink";

export enum SocialMediaPillType {
  Connect = "connect",
  Connected = "connected",
  Subscribers = "subscribers",
  Clean = "clean",
}

export enum SocialMediaPillSize {
  Regular = "regular",
  Small = "small",
}

interface Props {
  variant: SocialMediaPlatformCode;
  subscribersCount?: number;
  isEdit?: boolean;
  type?: SocialMediaPillType;
  size?: SocialMediaPillSize;
  className?: string;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  onRemoveClick?: () => void;
}

const SocialMediaIconMap = {
  [SocialMediaPlatformCode.Instagram]: InstagramIcon,
};

const SocialMediaPill = ({
  variant,
  onClick,
  onRemoveClick,
  className,
  type = SocialMediaPillType.Connected,
  size = SocialMediaPillSize.Regular,
  subscribersCount = 0,
  isEdit,
}: Props) => {
  const { t } = useTranslation();
  const isSmall = size === SocialMediaPillSize.Small;
  const iconSize = isSmall ? 18 : 24;
  const buttonClassName = cx(
    "social-media-pill",
    {
      "social-media-pill--small": isSmall,
    },
    className
  );
  const textClassName = cx("text", {
    "text--small": isSmall,
  });

  const SocialMediaIcon = SocialMediaIconMap[variant];

  return (
    <IconTextLink
      svgIconStart={<SocialMediaIcon height={iconSize} width={iconSize} />}
      svgIconEnd={
        isEdit && (
          <button
            className="close"
            onClick={(e) => {
              e.stopPropagation();
              onRemoveClick?.();
            }}
          >
            <CloseIcon height={10} width={10} />
          </button>
        )
      }
      renderLabel={
        <div className={textClassName}>
          {getSocialPillText({
            t,
            type,
            variant,
            subscribersCount,
          })}
        </div>
      }
      variant="button-icon-text"
      className={buttonClassName}
      onClick={onClick}
    />
  );
};

export default SocialMediaPill;
